import {
  FETCH_BRANDING,
  SELECT_THEME_COLOR,
  THEME_COLORS,
  UPDATE_EVENT_ICON_LOCALLY,
  UPDATE_EVENT_COVER_LOCALLY,
  UPDATE_WEB_ICON_LOCALLY,
  UPDATE_WEB_COVER_LOCALLY,
  SELECT_WEB_THEME_COLOR,
  WEB_THEME_COLORS,
  SIDE_OR_BOTTOM_MENU_UPDATED,
  EDIT_APP_BOTTOM_MENU,
  CREATED_MENU,
  SPLASH_SCREEN_DATA,
} from "BrandingAction";

export function brandingReducers(state = [], action) {
  switch (action.type) {
    case FETCH_BRANDING:
      return action.payload.resource;
      break;
    default:
      return state;
  }
}

export function brandingLocalIconImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATE_EVENT_ICON_LOCALLY:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function brandingLocalCoverImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATE_EVENT_COVER_LOCALLY:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function brandingColorReducers(state = {}, action) {
  switch (action.type) {
    case SELECT_THEME_COLOR:
      return action.payload.resource;
      break;
    default:
      return state;
  }
}

export function brandingThemeColorsReducers(
  state = [
    { color: "#3E8DFA", custom: false, selected: true },
    { color: "", custom: true, selected: false },
  ],
  action
) {
  switch (action.type) {
    case THEME_COLORS:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function brandingLocalWebIconImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATE_WEB_ICON_LOCALLY:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function brandingLocalWebCoverImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATE_WEB_COVER_LOCALLY:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function brandingWebColorReducers(state = {}, action) {
  switch (action.type) {
    case SELECT_WEB_THEME_COLOR:
      return action.payload.resource;
      break;
    default:
      return state;
  }
}

export function brandingWebThemeColorsReducers(
  state = [
    { color: "#3E8DFA", custom: false, selected: true },
    { color: "", custom: true, selected: false },
  ],
  action
) {
  switch (action.type) {
    case WEB_THEME_COLORS:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function isUpdatedSideBottomAppMenu(
  state = { sidemenu: false, bottommenu: false },
  action
) {
  switch (action.type) {
    case SIDE_OR_BOTTOM_MENU_UPDATED:
      return action.payload;
      break;
    default:
      return state;
  }
}

export function EditAppBottomMenuReducer(state = false, action) {
  switch (action.type) {
    case EDIT_APP_BOTTOM_MENU:
      return action.payload;
    default:
      return state;
  }
}

export function createdMenu(state = {}, action) {
  if (action.type === CREATED_MENU) {
    return action.payload;
  }
  return state;
}

export function splashScreenData(state = [], action) {
  if (action.type === SPLASH_SCREEN_DATA) {
    return action.payload;
  }
  return state;
}
